<template>
    <div class="grid grid-cols-2 gap-4">
        <section>
            <h2 class="mb-4 text-heading-md">Plain Cards</h2>
            <div class="space-y-4">
                <div>
                    <h3 class="mb-2 text-content-lg font-semibold">Empty Content</h3>
                    <DsCard />
                </div>

                <div>
                    <h3 class="mb-2 text-content-lg font-semibold">Single Line Text</h3>
                    <DsCard> This is a single line of text content in a plain card. </DsCard>
                </div>

                <div>
                    <h3 class="mb-2 text-content-lg font-semibold">Multiline Text</h3>
                    <DsCard>
                        <p class="text-content-md">
                            This is a multiline text example in a plain card. It demonstrates how the card expands to accommodate
                            longer content.
                        </p>
                        <p class="mt-2 text-content-md">
                            The card maintains consistent padding and styling regardless of the amount of content inside it. This
                            ensures a uniform appearance across different use cases.
                        </p>
                    </DsCard>
                </div>

                <div>
                    <h3 class="mb-2 text-content-lg font-semibold">Text and Image Row</h3>
                    <DsCard>
                        <div class="flex items-center gap-4">
                            <img
                                alt="Placeholder"
                                class="h-16 w-16 rounded-lg object-cover"
                                src="https://fastly.picsum.photos/id/688/800/400.jpg?hmac=IoWYe7eCnG0v6haDsIuq6ro7NCxTeOAN-aIIlMULDac"
                            />
                            <div class="flex-1">
                                <h4 class="text-content-lg font-semibold">Card Title</h4>
                                <p class="text-content-sm text-content-secondary">Supporting text with an image</p>
                            </div>
                        </div>
                    </DsCard>
                </div>
            </div>

            <h2 class="mt-12 text-heading-md">Error state</h2>
            <b class="my-4">Error message</b>
            <div class="my-4">
                <DsCard error="This is an error message"> A wild error was found! </DsCard>
            </div>
            <b class="my-4">Error state (boolean)</b>
            <div class="space-y-4">
                <DsCard :error="true"> Omg the content here is not good </DsCard>
            </div>
            <div class="my-4">
                <b class="my-4">Error state (boolean) + selected state</b>
                <DsCard
                    :error="true"
                    selected
                >
                    Error supersedes selected state
                </DsCard>
            </div>
        </section>

        <section>
            <section>
                <h2 class="mb-4 text-heading-md">Interactive Cards</h2>
                <div class="space-y-4">
                    <div>
                        <h3 class="mb-2 text-content-lg font-semibold">Clickable <small>(default if interactive)</small></h3>
                        <DsCard variant="interactive" />
                    </div>
                    <div>
                        <h3 class="mb-2 text-content-lg font-semibold">Non clickable</h3>
                        <DsCard
                            :clickable="false"
                            variant="interactive"
                        />
                    </div>
                </div>
            </section>

            <section>
                <h2 class="mb-4 text-heading-md">Additional Examples</h2>
                <div class="space-y-4">
                    <div>
                        <h3 class="mb-2 text-content-lg font-semibold">Complex Card Content</h3>
                        <DsCard>
                            <div class="space-y-4">
                                <div class="flex items-start justify-between">
                                    <h3 class="text-heading-sm">Project Status</h3>
                                    <DsBadge
                                        text="Active"
                                        variant="active"
                                    />
                                </div>

                                <div class="space-y-2">
                                    <div class="flex justify-between text-content-md">
                                        <span class="text-content-secondary">Progress</span>
                                        <span class="font-semibold">75%</span>
                                    </div>
                                    <div class="h-2 w-full rounded-full bg-ds-gray-200">
                                        <div
                                            class="h-2 rounded-full bg-ds-gray-900"
                                            style="width: 75%"
                                        ></div>
                                    </div>
                                </div>

                                <div class="flex gap-2 pt-2">
                                    <DsButton
                                        size="sm"
                                        variant="secondary"
                                    >
                                        View Details
                                    </DsButton>
                                    <DsButton
                                        size="sm"
                                        variant="primary"
                                    >
                                        Edit
                                    </DsButton>
                                </div>
                            </div>
                        </DsCard>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script setup lang="ts">
import DsBadge from '@/components/design-system/badge/DsBadge.vue';
import DsCard from '@ds/DsCard.vue';
import DsButton from '@ds/form/input/DsButton.vue';
</script>

<style scoped lang="scss">
section {
    @apply p-4;
}
</style>
